import { AdminAuditLogDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAdminAuditLogs(searchParams: string) {
  const url = `/v2/orm/admin/audit-logs?${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<AdminAuditLogDTO>(request, {
    queryKey: ['admin-audit-logs', { searchParams }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useAdminAuditLogs;
